import ApiService from "../common/apiService";
import TokenService from "../common/tokenService";

import { GET_FACILITY_DOCUMENTS, UPLOAD_FACILITY_DOCUMENT, PREVIEW_FACILITY_DOCUMENT, DOWNLOAD_FACILITY_DOCUMENT, DOWNLOAD_FACILITY_DOCUMENTS} from "./actions.type";
import {forceDownload, filePreview} from "@/common/documentFunctions"
import {formatDate} from "../common/formatting";
import constants from "../common/constants";

const FacilityDocumentModule = {
  state: {
    errors: null,
    token: TokenService.getToken(),
    twoFactorAuth: {
      method: null,
      completed: null
    },
    facilityDocuments: {},
    facilityDocumentsUrl: "/facilitydocuments"
  },
  mutations:{
    storeFacilityDocuments (state, documentData) {
      state.facilityDocuments.received = documentData.received;
      state.facilityDocuments.submitted = documentData.submitted;
    },
    formatFacilityDocuments(state) {
      var docUrl = this.getters.getFacilityDocumentsUrl + '/';
      var frmtDocs = [];
      //Only two loops received/submitted
      Object.keys(state.facilityDocuments).forEach( function (docType, key) {
        //docType = received/submitted
        frmtDocs[docType] = [];
        //Loop through each document for given type.
        state.facilityDocuments[docType].forEach(function(doc, i) {
          let newDoc = {
            data: {
              id: doc.id
            },
            actions: [
              {
                link: docUrl + 'preview/'+doc.facility_id+'/'+doc.id,
                icon: 'show'
              },
              {
                link: docUrl + doc.id,
                icon: 'download'
              }
            ],
            dateUploaded: {
              value: formatDate(doc.created_at),
              realValue: doc.created_at
            },
            desc: {
              value: doc.description
            },
            docName: {
              value: doc.name
            },
          };
          frmtDocs[docType].push(newDoc);
          if (doc.hasOwnProperty('user')) {
            newDoc.uploadedBy = {value: constants.updateUploadedBy(doc.description, `${doc.user.first_name} ${doc.user.last_name}`)};
          }
        });
      });
      state.facilityDocuments.received = frmtDocs['received'];
      state.facilityDocuments.submitted = frmtDocs['submitted'];
    }
  },
  getters: {
    getFacilityDocumentsUrl: state => {
      return state.facilityDocumentsUrl;
    },
    submittedFacilityDocuments: state => {
      return state.facilityDocuments.submitted;
    },
    receivedFacilityDocuments: state => {
      return state.facilityDocuments.received;
    }
  },
  actions: {
    [GET_FACILITY_DOCUMENTS](context,payload){
      return new Promise((resolve,reject)=>{
          let url = this.getters.getFacilityDocumentsUrl+'/list/'+payload.facilityId;
          ApiService.get(url)
            .then(({data}) => {
              this.commit('storeFacilityDocuments', data);
              this.commit('formatFacilityDocuments');
              resolve();
            })
            .catch(error => {
              reject(error)
            })
        }
      );
    },
    [DOWNLOAD_FACILITY_DOCUMENT](context,payload){
      return new Promise((resolve,reject)=>{
        let url = payload.url;
        ApiService.request({
          'method': 'get',
          'url': url,
          responseType: 'blob'
        }).then(response => {
            forceDownload(response);
            resolve(data);
          })
          .catch(error => {
            reject(error)
          });
      });
    },
    [DOWNLOAD_FACILITY_DOCUMENTS](context,payload){
      return new Promise((resolve,reject)=>{
        let url = this.getters.getFacilityDocumentsUrl + '/bulk/367?';
        // for (let id of payload.selectedIds) {
        //   url += `ids[]=${id}&`
        // }
        url += `ids=${payload.selectedIds.join(',')}`
        ApiService.request({
          'method': 'get',
          'url': url,
          responseType: 'blob'
        }).then(response => {
            forceDownload(response);
            resolve();
          })
          .catch( response => {
            console.log(response);
          });
      });
    },
    [UPLOAD_FACILITY_DOCUMENT](context,payload){
      return new Promise((resolve,reject)=>{
          var formData = new FormData();
          formData.append('file', payload.file);
          formData.append('facilityId', payload.facilityId);
          formData.append('description', payload.description);
          let url = this.getters.getFacilityDocumentsUrl+'/upload';
          ApiService.post(url, formData)
            .then(({ data }) => {
                resolve( {
                  success: false,
                  error: data
                });
            }).catch(({ response }) => {
              var err = response.data;
              var errMsg = err.message;
              if (err.data) {
                for (let p in err.data) {
                  if (Object.prototype.hasOwnProperty.call(err.data, p)) {
                    errMsg += `,${err.data[p]}`;
                  } else {
                    errMsg += `,${p}`;
                  }
                }
              };
              reject({
                success: false,
                error: errMsg
              });
            })
        }
      );
    },
    [PREVIEW_FACILITY_DOCUMENT](context,payload){
      let url = payload.url;
      return new Promise((resolve,reject)=>{
        ApiService.request({
          'method': 'get',
          'url': url,
          responseType: 'blob'
        }).then( response => {
            resolve(filePreview(response));
          })
          .catch( response => {
            console.log(response);
          });
      });
    }
  }
};

export default FacilityDocumentModule;
